export const FETCH_STOCK_SUCCESS = "FETCH_STOCK_SUCCESS";
export const FETCH_STOCK_BEGIN = "FETCH_STOCK_BEGIN";
export const FETCH_STOCK_FAILURE = "FETCH_STOCK_FAILURE";
